import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { BUTTON__CONTENT_CLASS } from '../Button/constants';

const { responsiveText } = theme;

const paddingY = 10;
const paddingYCompact = 6;

const compactCommon = css`
  .${BUTTON__CONTENT_CLASS} {
    height: ${pxToRem(24)};
    ${responsiveText.BODY.SM};
  }
`;

export const buttonSize = (compact: boolean, fullWidth: boolean) => {
  if (compact && fullWidth) {
    return css`
      padding: ${pxToRem(paddingYCompact)} 0;
      width: 100%;
      ${compactCommon}
    `;
  }

  if (compact) {
    return css`
      padding: ${pxToRem(paddingYCompact)} 34px;
      ${compactCommon}
    `;
  }

  if (fullWidth) {
    return css`
      padding: ${pxToRem(paddingY)} 0;
      width: 100%;
    `;
  }

  return css`
    padding: ${pxToRem(paddingY)} 52px;
  `;
};
